import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useModuleSettings } from "../moduleSettingsContext/ModuleSettingsContext";

const AppSidebar = () => {
  const { resetSettings } = useModuleSettings();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.feather) {
      window.feather.replace();
    }
  }, [location.pathname]);

  const handleNavigation = () => {
    resetSettings();
    setTimeout(() => {
      if (window.feather) {
        window.feather.replace();
      }
    }, 0);
  };

  const menuItems = [
    {
      items: [
        { route: "/dashboard", icon: "airplay", text: "Dashboards" },
        { route: "/course", icon: "book-open", text: "My Courses" },
        { route: "/test", icon: "file-text", text: "Test" },
        {
          route: "#sidebarReview",
          icon: "star",
          text: "Review",
          name: "review",
          subItems: [
            { route: "/review/course", text: "Course Reviews" },
            { route: "/review/my-reviews", text: "My Reviews" }
          ],
        },
        { route: "/community-forum", icon: "message-square", text: "Community Forum" },
        { route: "/blog", icon: "edit", text: "Blogs" },
        { route: "/chat", icon: "message-circle", text: "Chat" },
        {
          route: "#sidebarSetting",
          icon: "settings",
          text: "Settings",
          subItems: [
            { route: "/edit-profile", text: "Edit Profile" },
            { route: "/change-password", text: "Change Password" },
          ],
        },
        {
          route: "#sidebarCrm",
          icon: "users",
          text: "CMS",
          subItems: [
            { route: "/about", text: "About Us" },
            { route: "/privacy-policy", text: "Privacy Policy" },
            { route: "/terms-condition", text: "Term & Condition" },
            { route: "/faq", text: "FAQ" },
          ],
        },
      ],
    },
  ];

  return (
    <div className="left-side-menu" style={{ overflowY: "auto" }}>
      <div className="h-100">
        <div className="user-box text-center">
          {/* User avatar and dropdown */}
        </div>
        <div id="sidebar-menu">
          <ul id="side-menu">
            {menuItems.map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                {section.items.map((item, itemIndex) => {
                  const isActive = location.pathname === item.route;
                  const isSubOpen = item?.subItems?.some((val) => location.pathname === val.route);
                  
                  return (
                    <li key={itemIndex} className={isActive || isSubOpen ? "menuitem-active" : ""}>
                      <Link
                        to={item.route}
                        data-bs-toggle={item.subItems ? "collapse" : undefined}
                        onClick={handleNavigation}
                      >
                        <i data-feather={item.icon} />
                        <span> {item.text} </span>
                        {item.subItems && <span className="menu-arrow" />}
                      </Link>
                      {item.subItems && (
                        <div className="collapse" id={item.route.substring(1)}>
                          <ul className="nav-second-level">
                            {item.subItems.map((subItem, subItemIndex) => {
                              return(
                              <li key={subItemIndex} className={location.pathname === subItem.route ? "menuitem-active" : ""}>
                                <Link to={subItem.route}>{subItem.text}</Link>
                              </li>
                            )})}
                          </ul>
                        </div>
                      )}
                    </li>
                  );
                })}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AppSidebar;